import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { HeaderWrapper as Wrapper } from 'ds/components/Layout';

export const BackButtonWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scaleX(-1);
`;

export const Inner = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderWrapper = styled(Wrapper)`
  position: fixed;
  left: 0;
`;

export const Title = styled(Text)<{ show: boolean }>`
  transition: opacity .2s ease;
  opacity: ${({ show }) => show ? 1 : 0};
`;

export const ActionIcons = styled.div`
  display: flex;
  flex-direction: row;

  > div:not(:last-of-type) {
    margin-left: ${({ theme }) => theme.spacing(3)};
  }
`;

export const DeveloperName = styled(Text.withComponent('h1'))``;
